import { Component, OnInit, OnDestroy, Compiler, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import { CookieService } from 'ngx-cookie-service';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-survey-list',
	templateUrl: './survey-list.component.html',
	styleUrls: ['./survey-list.component.css']
})
export class SurveyListComponent implements OnInit {
	surveyForm: any;
	surveyList: any;
	stateList: any;
	cityList: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	countryList: any;
	base64textString: any;
	attached_image: any;
	flashMsg: string;
	selectedSurveyData: any;
	selectedSurveyId: any;
	surveyTypeList: any;
	surveyExpiryList: any;
	surveyCategoryList: any;
	url: any;
	surveyType: any;
	isDeleteSurvey: boolean;
	deleteSelectedSurveyData: any;
	searchStr: any = "";
	surveyCategory: any = "";
	surveyStatus: any = "";
	isSurveyAvailable: boolean = false;
	isCityfilter: boolean = false;
	redirectUrl: any;
	activePageNo: number = 0;
	country_id:string = '';
	likeUserArr:any  = [];
	selectSurvayLike:any = [];
	@ViewChild('videoPlayer') videoplayer: ElementRef;
	src:String = "";
	viewType:string = "";

	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService, private cookieService: CookieService) { }

	ngOnInit() {
		this.initialiseSurvey();
		this.getCountryList();
		this.commonService.process();

	}

	// Get StateList
	onChange(Country_id) {
		this.country_id = Country_id;
		this.authService.getStateListbyId(Country_id).subscribe(data => {
			if (data.success) {
				this.stateList = data.state;
			}
		})
	}

	// Get CityList
	onChangeState(State_id) {
		this.authService.getCityListbyId(State_id).subscribe(data => {
			if (data.success) {
				this.cityList = data.city;
				console.log(this.cityList);

			}
		})
	}


	// Get Country list
	getCountryList = function () {

		this.authService.getCountryList().subscribe(data => {
			if (data.success) {

				this.countryList = data.country;
			}
			else {
				this.isCountryAvailable = false;
				this.countryList = [];
			}
			this.commonService.hideProcess();
		});

	}

	// Get Survey List
	initialiseSurvey = function () {
		this.commonService.setTitle();
		this.limit = 10;
		this.pageNo = 1;
		this.url = '';
		this.surveyStatus = 0;
		//this.surveyTypeList = JSON.parse(this.cookieService.get('surveyTypeList'));

		// Get survey expiry date
		this.authService.getSurveyExpiryList().subscribe(data => {
			if (data.success) {
				this.surveyExpiryList = data.time;
			}
		});

		let route = this.router.url;
		if (route.indexOf("?") !== -1) {

			var routeArr = route.split('?backUrl=');
			var decodedUri = decodeURIComponent(routeArr[1]);
			var decodedArr = decodedUri.split("&");
			var decodedPageNo = decodedArr[0].split("pageNo=");
			this.pageNo = decodedPageNo[1];
			this.activePageNo = decodedPageNo[1];

			var decodedSurveyCategory = decodedArr[1].split("categoryId=");
			this.surveyCategory = decodedSurveyCategory[1];

			var decodedSurveyStatus = decodedArr[2].split("surveyStatus=");
			this.surveyStatus = decodedSurveyStatus[1];

			var decodedSearchStr = decodedArr[3].split("searchStr=");
			this.searchStr = decodedSearchStr[1];

			var decodedUrl = decodedArr[4].split("surveyTypeId=");
			this.url = decodedUrl[1];

			if (this.url == "5a66e31e85cfcd3f9289197c") {
				$(".navbar-brand").text("Country Surveys");
			}
			else if (this.url == "5a66e31e85cfcd3f9289197c") {
				$(".navbar-brand").text("World Surveys");
			} else {
				$(".navbar-brand").text("Surveys");
			}
		}
		if (route == "/survey-list") {
			this.url = '';
			$(".navbar-brand").text("Surveys");
		}
		if (route == "/country-survey-list") {
			this.url = "5a66e31e85cfcd3f9289197c";
			$(".navbar-brand").text("Country Surveys");
			this.isCityfilter = true;
		}
		if (route == "/city-survey-list") {
			this.url = "5cd401a5c5bd18148c2f040f";
			$(".navbar-brand").text("City Surveys");
			this.isCityfilter = true;
		}
		if (route == "/world-survey-list") {
			this.url = "5a66e31385cfcd3f9289197b";
			$(".navbar-brand").text("World Surveys");
		}

		// Get survey category list
		this.authService.getSurveyCategoryList().subscribe(data => {
			if (data.success) {
				var that = this;
				this.surveyCategoryList = data.category;
				setTimeout(function () {
					$("#surveyCategory").val(that.surveyCategory);
					$("#surveyStatus").val(that.surveyStatus);
					$("#search").val(that.searchStr);
					$('#page_' + that.activePageNo).addClass('active');
					if (that.activePageNo == 1)
						$('#first, #prev').addClass('disabled');
					else if (that.activePageNo == that.pager.totalPages)
						$('#next, #last').addClass('disabled');
				}, 300);
			}
		});

		// Get survey list
		this.getSurveyList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);

		this.surveyForm = new FormGroup({
			question: new FormControl("", Validators.compose([
				Validators.required,
				Validators.maxLength(100),
				Validators.minLength(10),
			])),

			option_1: new FormControl("", Validators.compose([
				Validators.required,
				Validators.maxLength(50)
			])),

			option_2: new FormControl("", Validators.compose([
				Validators.required,
				Validators.maxLength(50)
			])),

			option_3: new FormControl("", Validators.maxLength(50)),

			option_4: new FormControl("", Validators.maxLength(50)),

			option_5: new FormControl("", Validators.maxLength(50)),

			survey_type_id: new FormControl("", Validators.compose([
				Validators.required
			])),

			survey_expired_time: new FormControl("", Validators.compose([
				Validators.required
			])),

			survey_category_id: new FormControl("", Validators.compose([
				Validators.required
			])),

			tags: new FormControl("", Validators.compose([
				// Validators.required
			])),
		});
	}

	// Get survey list
	getSurveyList = function (pageNo, limit, surveyTypeId, categoryId, surveyStatus, searchStr) {

		this.commonService.process();
		this.authService.getSurveyList(pageNo, limit, surveyTypeId, categoryId, surveyStatus, searchStr,this.country_id).subscribe(data => {

			if (data.success) {

				this.isSurveyAvailable = false;
				this.surveyList = data.survey;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.redirectUrl = "pageNo=" + pageNo + "&categoryId=" + categoryId + "&surveyStatus=" + surveyStatus + "&searchStr=" + searchStr + "&surveyTypeId=" + surveyTypeId + "&country_id="+this.country_id;
			}else{
				this.surveyList = [];
				this.isSurveyAvailable = true;
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		//$('.pages').removeClass('active')
		$('.pages.active a').each(function () {
			if (parseInt($(this).text()) != page)
				$(this).parent('li').removeClass('active');
		});
		if ($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			$('#first, #prev').removeClass('disabled');
		if ($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			$('#next, #last').removeClass('disabled');

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.surveyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getSurveyList(page, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
		}
	}

	// Update user functionality.
	updateSelectedSurvey = function (selectedSurveyData) {
		this.surveyForm.reset();
		this.selectedSurveyId = selectedSurveyData._id;
		// Set controls
		this.surveyForm.controls['question'].setValue(selectedSurveyData.question);
		if (selectedSurveyData.option.length > 0) {
			selectedSurveyData.option.forEach((item, index) => {
				this.surveyForm.controls['option_' + (index + 1)].setValue(selectedSurveyData.option[index].slice(0, -1));
			});
		}
		this.surveyForm.controls['survey_type_id'].setValue(selectedSurveyData.survey_type_id._id);
		this.surveyForm.controls['survey_category_id'].setValue(selectedSurveyData.survey_category_id._id);
		this.surveyForm.controls['survey_expired_time'].setValue(selectedSurveyData.survey_expired_time._id);
		this.surveyForm.controls['tags'].setValue(selectedSurveyData.tags);
	}

	likeViewSelectedSurvey = function(aregument){
		var userIds = [];
		this.selectSurvayLike = aregument;
		
		console.log(this.selectSurvayLike);

		if(aregument){
			aregument.forEach(element => {
				userIds.push(element.userid);
			});
			this.authService.likesurveyusers({"userIds":userIds}).subscribe(res => {
				if (res.success) {
					this.likeUserArr = res.userData;
				}else {
					jQuery.growl.error({ title: 'Error', message: res.error });
				}
			});
		}

	
	}

	onSubmit = function (data) {
		if (!this.surveyForm.valid) {
			this.validationService.validateAllFormFields(this.surveyForm);
			return;
		}

		this.options = [[data.option_1, "0"], [data.option_2, "0"]];
		if (data.option_3) {
			this.options.push([data.option_3, "0"]);
		}
		if (data.option_4) {
			this.options.push([data.option_4, "0"]);
		}
		if (data.option_5) {
			this.options.push([data.option_5, "0"]);
		}
		data.option = this.options;
		data.attached_image = this.attached_image;
		delete data.option_1;
		delete data.option_2;
		delete data.option_3;
		delete data.option_4;
		delete data.option_5;

		data.expiry_time = new Date();
		if (data.survey_expired_time == '5a66e3d285cfcd3f9289197d') {
			(data.expiry_time).setDate((data.expiry_time).getDate() + 1);
		}
		else if (data.survey_expired_time == '5a66e3dd85cfcd3f9289197e') {
			(data.expiry_time).setDate((data.expiry_time).getDate() + 7);
		}
		else {
			(data.expiry_time).setDate((data.expiry_time).getDate() + 30);
		}
		this.authService.updateSurvey(data, this.selectedSurveyId).subscribe(res => {
			if (res.success) {
				data._id = this.selectedSurveyId;
				this.authService.cancelProcess();
				this.getSurveyList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
				jQuery.growl.notice({ title: 'Success', message: res.message });
			}
			else {
				jQuery.growl.error({ title: 'Error', message: res.error });
			}
		});
	}

	// Delete selected Survey Details
	deleteSelectedSurvey = function (survey) {
		// debugger;;
		this.isDeleteSurvey = true;
		this.deleteSelectedSurveyData = survey
	}

	// Delete Survey
	deleteSurvey = function (id) {

		this.authService.deleteSurvey(id).subscribe(data => {
			// debugger;
			if (data.success) {
				this.authService.cancelProcess();
				this.getSurveyList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
				jQuery.growl.notice({ title: 'Success', message: data.message });
			}
			else {
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}

	// Upload Survey image functionality
	handleFiles = function (fileInput: Event) {
		this.imageArr = ['image/jpeg', 'image/jpg', 'image/png'];
		if (fileInput.target['files'][0]['size'] > 500000) {
			jQuery.growl.error({ title: 'Error', message: "File can not be larger than 0.5 MB" });
			return;
		}
		if (!this.imageArr.includes(fileInput.target['files'][0]['type'])) {
			jQuery.growl.error({ title: 'Error', message: "Invalid file format." });
			return;
		}
		var reader = new FileReader();
		reader.onload = this._handleReaderLoaded.bind(this);
		reader.readAsBinaryString(fileInput.target['files'][0]);
	}

	_handleReaderLoaded(readerEvt) {
		var binaryString = readerEvt.target.result;
		this.base64textString = btoa(binaryString);
		this.attached_image = 'data:image/jpeg;base64,' + this.base64textString;
		if (this.attached_image) {
			this.flashMsg = "Image uploaded successfully!";
		}
	}

	// Update survey status .
	updateSurveyStatus = function (surveyId) {
		this.authService.updateSurveyStatus(surveyId).subscribe(data => {
			if (data.success) {
				jQuery.growl.notice({ title: 'Success', message: data.message });
			}
			else {
				$('#chk_' + surveyId).click();
				$('#chk_' + surveyId).is(':checked') ? $('#chk_' + surveyId).next('span.toggler').removeClass('off') : $('#chk_' + surveyId).next('span.toggler').addClass('off')
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}

	// Search survey
	searchSurvey = function () {
		this.searchStr = $("#search").val();
		this.surveyCategory = $("#surveyCategory").val();
		this.surveyStatus = $("#surveyStatus").val();
		this.getSurveyList(1, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
	}

	toggleVideo(event: any) {
		this.videoplayer.nativeElement.play();
	}

	playVideo(data,type){
		if(type=='video'){
			this.viewType = "video";
			this.src = data.attached_image ? data.attached_image : '';
		}else{
			this.viewType = "image";
			this.src = data.optionimage ? data.optionimage : '../../../assets/img/image-not-found.jpg';
		}
	}

}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/survey-list/survey-list.component.ts